import styled from 'styled-components'

export const ButtonHamburger = styled.button`
  background: white;
  display: inline-block;
  width: 50px;
  height: 50px;
  border: none;
  position: relative;
  border-radius: 3px;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  @media screen and (min-width: 1025px) {
    display: none;
  }

  &.active {
    span {
      background: transparent;
      &:before,
      &:after {
        top: 0;
        left: 0;
      }
      &:before {
        transform: rotate(-45deg);
      }
      &:after {
        transform: rotate(45deg);
      }
    }
  }

  span {
    background: black;
    border-radius: 10px;
    display: inline-block;
    height: 3px;
    width: 70%;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    &:before,
    &:after {
      content: '';
      background: black;
      border-radius: 10px;
      display: inline-block;
      height: 3px;
      width: 100%;
      position: absolute;
      left: 0;
      transition: 0.3s;
    }

    &:before {
      top: -10px;
    }

    &:after {
      bottom: -10px;
    }
  }
`
